export enum EditOnSendType {
    AppendOnSend = 'AppendOnSend',
    PrependOnSend = 'PrependOnSend',
}

export default EditOnSendType;
